import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoFranquiaListarComponent } from './chamado-franquia-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: ChamadoFranquiaListarComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoFranquiaListarRoutingModule { }
